const gazDigital = document.querySelector('.gaz-digital');

if (null !== gazDigital) {
	const gazDigitalToggle = document.querySelector('.gaz-digital__new-arrow');
	gazDigitalToggle.onclick = () => {
		gazDigital.classList.toggle('gaz-digital--closed');
	};
}
